import React from "react";

const StaffHelpInstructions = () => {
  return (
    <div className="card-wrap" id="studentresource">
      <div className="title">
        <h2>Help</h2>
      </div>
      <div className="row help-wrap">
        <div className="col-lg-3 col-md-3">
          <div className="sidebar" id="sidebar">
            <h2>Table of Contents</h2>
            <a href="#introduction">Introduction</a>
            <a href="#login">Login</a>
            <a href="#dashboard">1. Dashboard</a>
            <a href="#resources">2. Resources</a>
            <a href="#employee-training">3. Employee Training</a>
            <a href="#reports">4. Reports</a>
            <a href="#communication">5. Communication</a>
            <a href="#notifications">6. Notifications</a>
            <a href="#feedback">7. Feedback</a>
            <a href="#settings">8. Settings</a>
            <a href="#navbar">9. Navigation Bar</a>
          </div>
        </div>
        <div className="col-lg-9 col-md-3">
          <div className="content">
            <div id="introduction" className="section">
              <h2>Introduction</h2>
              <p>
                This user manual serves as a comprehensive guide to help you
                navigate the Budu Portal with ease. It covers key features,
                step-by-step instructions, and tips to make the most of the
                portal’s capabilities.
              </p>
            </div>

            <div id="login" className="section">
              <h2>Login</h2>
              <p>
                The login page allows Staff users to securely sign in. Follow
                these steps:
              </p>
              <ol>
                <li>
                  Click the URL:{" "}
                  <a
                    href="https://demo.ui.buduportal.com/login"
                    target="_blank"
                  >
                    https://demo.ui.buduportal.com/login
                  </a>
                </li>
                <li>Enter username and password in the fields provided.</li>
                <li>Click the 'Login' button to access the main dashboard.</li>
              </ol>
              <img src="assets/images/help/login.png" alt="Login" />
            </div>

            <div id="dashboard" className="section">
              <h3>1. Dashboard</h3>
              <h3>1.1 Department Resources </h3>
              <ul>
                <li>
                  Navigate to the Department Resources section on your dashboard{" "}
                </li>
                <li>
                  Click on any resource tile, You will be redirected to the
                  corresponding URL
                </li>
                <li>
                  Click on "View All" to see the full list of available
                  department-related resources.{" "}
                </li>
              </ul>

              <h3>1.2 Your Power BI Reports</h3>
              <ul>
                <li>Display the reports available to the staff</li>
                <li>
                  By clicking on the reports, you will be redirected to the
                  Corresponding URL{" "}
                </li>
                <li>
                  Click on "View All" will be redirected to the “Reports”
                  section
                </li>
              </ul>

              <h3>1.3 Calendar</h3>
              <ul>
                <li>Navigate to the calendar view.</li>
                <li>
                  By default, the current month is displayed and the current
                  date is highlighted.{" "}
                </li>
                <li>
                  If any events are set for the selected day, a popup will
                  display the list of scheduled events.
                </li>
                <li>
                  The message "No events scheduled for this day" will appear if
                  there are no events. This indicates that no meetings, tasks,
                  or activities are planned for the selected date
                </li>
              </ul>

              <h3>1.4 HR & Benefits</h3>
              <ul>
                <li>Navigate to HR & Benefits</li>
                <li>
                  Click on a particular App, You will be redirected to the
                  corresponding URL
                </li>
                <li>Click on "View All" to view all HR & benefits list.</li>
              </ul>

              <h3>1.5 Finance Resources</h3>
              <ul>
                <li>Navigate to Finance Resources</li>
                <li>
                  Click on particular App will be redirected to the
                  corresponding URL
                </li>
                <li>Click on "View All" to see all finance resources</li>
              </ul>

              <h3>1.6 Popular Training</h3>
              <ul>
                <li>Navigate to Finance Resources </li>
                <li>
                  Clicking on a particular Training will be redirected to the
                  more details page of that Training{" "}
                </li>
                <li>
                  Click on "View All" redirect to the Employee Training Page.
                </li>
              </ul>

              <h3>1.7 Technology Resources</h3>
              <ul>
                <li>Navigate to Technology Resources </li>
                <li>
                  Click on any of the Technology Resources, you will be
                  redirected to the corresponding URL
                </li>
                <li>Click on "View All" to see all technology resources</li>
              </ul>

              <h3>1.8 Campus Events</h3>
              <ul>
                <li>This block will display the available Campus Events</li>
                <li>
                  Click on any event to be redirected to its respective URL
                </li>
                <li>Click on View All to see all the Campus Events</li>
              </ul>

              <h3>1.9 Campus Safety</h3>
              <ul>
                <li>Navigate to Campus Events</li>
                <li>
                  Click on any Campus Safety, you will be redirected to the
                  corresponding URL
                </li>
                <li>Click on "View All" to see all campus safety</li>
              </ul>
            </div>

            <div id="resources" className="section">
              <h2>2. Resources</h2>
              <h3>2.1 Staff Resources</h3>
              <ul>
                <li>Navigate to the faculty Resources page.</li>
                <li>Click on the faculty Resource widget.</li>
                <li>
                  When you click on each widget, the respective details are
                  displayed.
                </li>
                <li>
                  Click on the View Details button to be redirected to a
                  configured url
                </li>
              </ul>

              <h3>2.2 Staff Apps</h3>
              <ul>
                <li>Navigate to the faculty resource page.</li>
                <li>Click on the faculty app </li>
                <li>
                  When you click on each app, the respective details are
                  displayed.
                </li>
                <li>
                  Click on the View Details button to be redirected to a
                  configured url
                </li>
              </ul>
            </div>

            <div id="employee-training" className="section">
              <h2>3. Employee Training</h2>
              <h3>3.1 Employee Training</h3>
              <ul>
                <li>Navigate the “Employee Training” </li>
                <li>Displays the available training sessions for staff.</li>
                <li>
                  Click View More to open a popup window displaying detailed
                  information about the training.
                </li>
                <li>
                  Click the Register button to sign up for a training session.
                  You will be redirected to the registration link.
                </li>
                <li>
                  After successful registration, the Attend button will appear.
                  This button becomes active on the training start date.
                </li>
                <li>
                  Click the View All button to navigate to the complete list of
                  training sessions.
                </li>
              </ul>

              <h3>3.2 Training Metrics</h3>
              <ul>
                <li>Navigate to Training metrics page </li>
                <li>
                  You can see the details of Certificates Issued, Training
                  Completed, Training Not Taken
                </li>
              </ul>

              <h3>3.3 Training Help </h3>
              <ul>
                <li>Navigate to Training help session.</li>
                <li>
                  Click on a video to be redirected to the video URL and start
                  playback.
                </li>
                <li>
                  Click forward and backward arrows for changing the video.
                </li>
              </ul>

              <h3>3.4 Calendar</h3>
              <ul>
                <li>
                  By default, current week will be displayed, and current date
                  is highlighted and events for that day will be displayed{" "}
                </li>
                <li>
                  A list of scheduled events will appear for the selected day if
                  configured any event
                </li>
                <li>
                  The message "No events scheduled for this day" will appear if
                  there are no events. This indicates that no meetings, tasks,
                  or activities are planned for the selected date.
                </li>
                <li>
                  By clicking on view entire schedule button, will be redirected
                  to the google calendar of the user
                </li>
                <li>By clicking on the arrow can change the week</li>
              </ul>
            </div>

            <div id="reports" className="section">
              <h2>4. Reports</h2>
              <ul>
                <li>
                  The Report Page displays reports grouped by time period: Daily
                  Reports, Weekly Reports and Monthly Reports & Annual Reports
                </li>
                <li>
                  By default, 3 reports are shown under each category block.
                </li>
                <li>
                  Click View All to see the full list of reports in that
                  category.
                </li>
                <li>
                  Click on any report to be redirected to the University Report
                  Page for full details.
                </li>
              </ul>
            </div>

            <div id="communication" className="section">
              <h2>5. Communication</h2>
              <ul>
                <li>Navigate to staff communication page</li>
                <li>
                  You can communicate with other department staffs via Teams
                  chat, send mail, Zoom Ucaas call
                </li>
                <li>
                  Click on respective mode of communication which is redirected
                  to corresponding channel.
                </li>
                <li>Click on filter and select any department </li>
                <li>
                  The system will display a list of staff associated with the
                  selected department.
                </li>
              </ul>
            </div>

            <div id="notifications" className="section">
              <h2>6. Notifications</h2>
              <ul>
                <li>
                  Navigate to the Notifications section to view all
                  notifications
                  <li>
                    Notifications are listed with details including:
                    <ul>
                      <li>Category (e.g., Campus Safety, Management)</li>
                      <li>Date (e.g., 29 days ago)</li>
                      <li>Status (e.g., New)</li>
                    </ul>
                  </li>
                </li>
                <li>By default, all notifications will be displayed.</li>
                <li>
                  To filter, click the “Select Notification Type” dropdown and
                  choose a category such as Announcement, Management, Exam
                  Announcement, or Campus Safety. Only notifications of the
                  selected type will be shown.
                </li>
              </ul>
            </div>

            <div id="feedback" className="section">
              <h2>7. Feedback</h2>
              <p>
                The Feedback module allows users to send feedback messages and
                rate their experience with the system. It includes options to
                submit comments, suggestions, and star ratings.
              </p>
              <h3>7.1 Sending Feedback</h3>
              <ul>
                <li>
                  Click on the Feedback Menu and it will be redirected to the
                  Feedback Page
                </li>
                <img src="assets/images/help/feedback.png" alt="Feedback" />
                <li>Subject: Enter Subject</li>
                <li>
                  Message: Type your message or comments in the Message field.
                </li>
                <li>Send: Click the Send button to submit your feedback.</li>
                <li>
                  Cancel: Click the Cancel button to discard your feedback and
                  return to the previous page.
                </li>
              </ul>
              <h3>7.2 Rate Us</h3>
              <ul>
                <li>
                  Rate Us Button : Click on rate us button , a rating popup will
                  appear.
                </li>
                <img src="assets/images/help/rating.png" alt="Rate Us" />
                <li>Select star rating to reflect your experience.</li>
                <li>
                  Provide any additional comments or suggestions in the input
                  field.
                </li>
                <li>
                  Submit : Click the Submit button to record your rating and
                  feedback.
                </li>
                <li>
                  Cancel: Click the Cancel button to discard your feedback
                </li>
              </ul>
            </div>

            <div id="settings" className="section">
              <h2>8. Settings</h2>
              <h3>8.1 Edit Profile</h3>
              <p>
                The Edit Profile option allows users to update their display
                name and profile picture.
              </p>
              <ul>
                <li>Navigate to the Settings Page.</li>
                <li>
                  Edit Profile Button : By clicking a popup will appear for
                  editing profile.
                </li>
                <img
                  src="assets/images/help/editProfile.png"
                  alt="Edit Profile"
                />
                <li>
                  Edit Icon: Click on the current profile image to upload a new
                  one.
                </li>
                <li>
                  Username : Edit the Username field to update your display name
                  on the portal.
                </li>
                <li>Save Changes: Click to Saves updated profile details.</li>
                <li>Close : Closes the popup without saving any changes.</li>
              </ul>
              <h3>8.2 Visibility & Priority Settings of Apps and Widgets</h3>
              <p>
                This section allows users to customize the visibility and
                display order of apps and widgets in their portal.
              </p>
              <ul>
                <li>
                  In the Settings Page, all apps and widgets are listed along
                  with their current visibility and order.
                </li>
                <li>
                  Change Visibility: To hide an app or widget, uncheck the radio
                  button next to its name.
                </li>
                <li>
                  Change Display Order: Rearrange the apps and widgets by
                  dragging and dropping them into the desired order.
                </li>
              </ul>
            </div>

            <div id="navbar" className="section">
              <h2>9. Navigation Bar</h2>
              <ul>
                <li>
                  <p>
                    The BUDU Portal provides an AI-based Search that helps users
                    quickly find information. As you type, the system shows
                    helpful suggestions based on your past searches and
                    available data. If you enter a question, the AI chatbot will
                    open and provide answers. This makes it easy to locate what
                    you need and ensuring a smooth and efficient search
                    experience for all users.
                  </p>
                </li>
                <li>
                  Email: Clicking on the Email Icon will redirect to the Outlook
                  Mail Inbox.
                </li>
                <li>
                  Safety Alert Icon: On click, displays the latest early alerts
                  with details.
                  <ul>
                    <li>
                      Contact Team: Opens the Mail Compose Page pre-filled to
                      contact the safety team.
                    </li>
                    <li>
                      View More: Redirects to the University Campus Safety Alert
                      Page for additional information.
                    </li>
                  </ul>
                </li>
                <li>Notification Icon: Redirects to the Notifications Page.</li>
                <li>Communication Icon: Redirects to the communication Page</li>
                <li>
                  Profile Icon: Once the Logout button is clicked, you will be
                  logged out and redirected to the login page.{" "}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StaffHelpInstructions;
